(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["formhale-atlasarticle1"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('scroll', () => {
    const h = document.documentElement;
    const scrolled = (h.scrollTop) / (h.scrollHeight - h.clientHeight) * 100;
    const bar = document.querySelector('[data-fh-progress]');
    if (bar) bar.style.width = scrolled + '%';
    const parallax = document.querySelector('[data-fh-parallax]');
    if (parallax) parallax.style.transform = `translateY(${h.scrollTop * 0.15}px)`;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stockwarningcopy"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-stock-warning]').forEach(function (block) {
  var sweepEl = block.querySelector('[data-radar-sweep]');
  var radarBox = block.querySelector('[data-radar-box]');
  if (!sweepEl || !radarBox) return;

  var sensitivity = parseFloat(block.getAttribute('data-scroll-sensitivity')) || 0.6;
  var rotation = 0;
  var lastScrollY = window.scrollY;
  var ticking = false;

  function updateRadar() {
    var currentScrollY = window.scrollY;
    var delta = currentScrollY - lastScrollY;
    lastScrollY = currentScrollY;
    
    rotation += delta * sensitivity;

    var baseScale = 1.0;
    var scale = baseScale + (currentScrollY * 0.0012);

    radarBox.style.transform = 'translate(-50%, -50%) scale(' + scale + ')';
    sweepEl.style.transform = 'rotate(' + rotation + 'deg)';
    
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(updateRadar);
      ticking = true;
    }
  }, { passive: true });
});

(function() {
  const container = document.currentScript ? document.currentScript.previousElementSibling : document.querySelector('.stock-folder-container-{{ block.id }}');
  if (!container) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.2 });

  observer.observe(container);
})();

  } catch(e) { console.error(e); }
})();
})();
